import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { TwilightProvider } from 'loankeeper-common/components/hocs/Twilight'

import { chooseActiveTabById } from './actions'
import { getActiveTab, getTabLoadingState, getInfoPage } from './selectors'

const Info = ({ type, ID, hash, tabs }) => {
  const dispatch = useDispatch()

  const { activeTabName, loading, data } = useSelector((state) => {
    const activeTabNameResult = getActiveTab(state, { type, ID })
    const activeTab = tabs[activeTabNameResult]

    return {
      activeTabName: activeTabNameResult,
      loading: getTabLoadingState(state, {
        type,
        ID,
        page: activeTab.api,
      }),
      data: getInfoPage(state, {
        type,
        ID,
        page: activeTab.api,
      }),
    }
  })

  const activeTab = tabs[activeTabName]
  const Component = activeTab.component

  function switchTab(tab) {
    dispatch(chooseActiveTabById({ tab, hash, type, ID }))
  }

  return (
    <TwilightProvider loading={loading}>
      <Component type={type} ID={ID} hash={hash} data={data} switchTab={switchTab} />
    </TwilightProvider>
  )
}

export default Info
